import { Button, type ButtonProps } from "@mantine/core";
import type * as React from "react";

type Props = Omit<ButtonProps, "variant" | "color"> & Omit<React.ComponentPropsWithRef<"button">, keyof ButtonProps>;

/**
 * The panel's buttons name a role, as the add-in's do (R10): the committing action is
 * Mantine's default filled `brand/7` Button; these are the other two.
 *  - SecondaryButton: Cancel, Close, Reload, navigation (Figma "Cancel": white, outlined,
 *    regular weight).
 *  - DangerButton: a destructive action and its confirm (outline red).
 */
export function SecondaryButton(props: Props) {
  return <Button variant="default" fw={400} {...props} />;
}

export function DangerButton(props: Props) {
  return <Button variant="outline" color="red" {...props} />;
}
